$(function()
{
    const singleItemParallax = $(".single-item-parallax");

    $(window).on("scroll", function()
    {
        const scroll = $(document).scrollTop();

        singleItemParallax.css({
            "background-position": "0% " + (-.4 * scroll) + "px"
        });
    });

    $(window).scroll(function()
    {
        const isDesktop = window.matchMedia("(min-width: 768px)").matches;
        const offset = 250;
        const duration = 300;

        if (!isDesktop)
        {
            if ($(this).scrollTop() > offset)
            {
                $(".back-to-top").fadeIn(duration);
                $(".back-to-top-center").fadeIn(duration);
            }
            else
            {
                $(".back-to-top").fadeOut(duration);
                $(".back-to-top-center").fadeOut(duration);
            }
        }
    });

    if (ThemeConfig.header.enableDropLeft === true || ThemeConfig.header.enableDropLeft == "true")
    {
        $("body").on("mouseover", ".main-navbar-collapsable.normalmenu .mainmenu > li.ddown", function()
        {
            const item = $(this);
            const distanceConfig = parseInt(ThemeConfig.header.dropLeftOffset);
            const windowWidth = $(window).width();
            const rightDistance = windowWidth - (item.offset().left + item.outerWidth());

            if (rightDistance < distanceConfig)
            {
                item.addClass("drop-left");
            }
            else
            {
                item.removeClass("drop-left");
            }
        });
    }

    if (!App.isShopBuilder)
    {
        if ($("#titleBeforeBreadcrumbs").length > 0)
        {
            $("[data-component=\"breadcrumbs\"]").each(function()
            {
                $(this).addClass("moved");
                $(this).insertAfter($("#titleBeforeBreadcrumbs"));
            });
        }
        else
        {
            $("[data-component=\"breadcrumbs\"]").each(function()
            {
                $(this).addClass("visible");
            });
        }
    }

    const navbarMenu = document.querySelector(".navbar-menu:not(.unfixed)");

    if (navbarMenu)
    {
        const navbarMenuObserver = new MutationObserver((mutations) =>
        {
            mutations.forEach((mutationRecord) =>
            {
                if (navbarMenu.style.top == "0px")
                {
                    navbarMenu.classList.add("sticky");
                }
                else
                {
                    navbarMenu.classList.remove("sticky");
                }
            });
        });

        navbarMenuObserver.observe(navbarMenu, { attributes: true, attributeFilter: ["style"] });
    }

    $("body").on("click", "[data-pl-collapse]", function()
    {
        const id = $(this).attr("data-pl-collapse");

        if (id)
        {
            const collapseBlock = $("[data-pl-cl=\"" + id + "\"]");
            const icon = $(this).find("i");

            if (icon.length && collapseBlock.length)
            {
                if (collapseBlock.is(":hidden"))
                {
                    icon.removeClass("pl-chevron-down");
                    icon.addClass("pl-chevron-up");
                }
                else
                {
                    icon.removeClass("pl-chevron-up");
                    icon.addClass("pl-chevron-down");
                }
                collapseBlock.slideToggle("slow");
            }
        }
        return false;
    });

    $(".fake-filter-toggle").on("click", function()
    {
        $("body").addClass("menu-is-visible");
        $(".customf-side-bar").addClass("open");

        return false;
    });

    $(".customf-side-bar-close").on("click", function()
    {
        $("body").removeClass("menu-is-visible");
        $(".customf-side-bar").removeClass("open");
    });

    $("body").on("click", ".btn[data-toggle='modal'][href='#login']", function()
    {
        window.ceresStore.dispatch("loadComponent", "login-modal");
    });

    $("body").on("click", ".item-set-description .description-trigger", function()
    {
        const modalContent = $(this).closest(".item-set-description").find(".description-content").html();

        if (modalContent.trim())
        {
            $("#item-set-desc-modal-wrapper .modal-body").html(modalContent);
            $("#item-set-desc-modal-wrapper .item-set-desc-modal").modal("show");
        }

        return false;
    });
});
